// Feature flags for feature toggles
export const FEATURE_FLAGS = {
  DEMO_MODE: true,
  BLOCK_MALAYSIA_FROM_MOVA: true,
};
